/**
 * Centralized error handling utility for API responses
 */

export const handleApiError = (error, customMessage = null, t = null) => {
  console.error('API Error:', error);
  
  if (error.response) {
    const { status, data } = error.response;
    
    switch (status) {
      case 401:
        // 401 errors are handled by the axios interceptor
        return 'Authentication failed. Please log in again.';
      case 402:
        // Subscription required - translate if t function provided
        if (t && data?.detail === 'SUBSCRIPTION_REQUIRED') {
          return t('subscription.subscriptionRequired') + '. ' + t('subscription.activateToAccess');
        }
        return data?.detail || 'Subscription required. Please activate your subscription to continue.';
      case 403:
        return 'You do not have permission to perform this action.';
      case 404:
        return 'The requested resource was not found.';
      case 429:
        return 'Too many requests. Please try again later.';
      case 500:
        return 'Server error. Please try again later.';
      default:
        return data?.message || data?.detail || customMessage || 'An unexpected error occurred.';
    }
  } else if (error.request) {
    return 'Network error. Please check your connection and try again.';
  } else {
    return customMessage || 'An unexpected error occurred.';
  }
};

export const isAuthError = (error) => {
  return error.response?.status === 401;
};

export const isNetworkError = (error) => {
  return !error.response && error.request;
};